import keenNavigationPlugin from "@/shared/components/keen-slider/plugins/keen-navigation-plugin";
import { documentReady } from "@sazka/utils/document-ready";
import KeenSlider from "keen-slider";

documentReady(() => {
    const drawWinnersCarousel = document.getElementById("wheelDrawWinnersCarousel");
    if (drawWinnersCarousel) {
        const autoplayEnabled = drawWinnersCarousel.dataset?.carouselAutoplay?.toLowerCase() === "true";

        const slider = new KeenSlider(
            drawWinnersCarousel,
            {
                breakpoints: {
                    "(min-width: 768px)": {
                        slides: { perView: 2, spacing: 0 },
                    },
                },
                selector: ".winners__winner-wrap",
                slides: {
                    perView: 1,
                    spacing: 0,
                },
                defaultAnimation: {
                    duration: 2000,
                },
            },
            [keenNavigationPlugin]
        );

        if (autoplayEnabled) {
            let interval: ReturnType<typeof setInterval> | number = 0;

            function autoplay(run) {
                clearInterval(interval);
                interval = setInterval(() => {
                    if (run && slider) {
                        if (slider.track.details.abs == slider.track.details.maxIdx) {
                            slider.moveToIdx(0);
                        } else {
                            slider.next();
                        }
                    }
                }, 2000);
            }

            autoplay(true);

            drawWinnersCarousel.addEventListener("mouseover", () => {
                autoplay(false);
            });
            drawWinnersCarousel.addEventListener("mouseout", () => {
                autoplay(true);
            });
        }
    }
});
